import {
  getUserMeWithPermissions,
  getAllUsers,
  getAllUsersByRoleCodename,
  createUser,
  updateUser,
  deleteUser,
  getUserById,
  getRolesByUserId,
  updateUsersRoles,
} from "@/modules/users/api";
import { dispatchNotification } from "@/modules/common/utils/notifications";

export default {
  namespaced: true,
  state: {
    DATA_USER_ME_WITH_PERMISSIONS: null,
    DATA_USERS: [],
    DATA_USERS_VERSION: 0,
    TOTAL_USERS: 0,
    DETAIL_DATA_USER: null,
    DATA_USER_ROLES: [],
    DATA_COURIERS: [],
  },

  getters: {
    GET_USER_ME_WITH_PERMISSIONS: (state: any) => {
      return state.DATA_USER_ME_WITH_PERMISSIONS;
    },
    GET_USERS: (state: any) => {
      return state.DATA_USERS;
    },
    GET_COURIERS: (state: any) => {
      return state.DATA_COURIERS;
    },
    GET_DATA_USERS_VERSION: (state: any) => {
      return state.DATA_USERS_VERSION;
    },
    GET_TOTAL_USERS: (state: any) => {
      return state.TOTAL_USERS;
    },
    GET_DETAIL_DATA_USER: (state: any) => {
      return state.DETAIL_DATA_USER;
    },
    GET_USER_ROLES: (state: any) => {
      return state.DATA_USER_ROLES;
    },
  },

  mutations: {
    SET_USER_ME_WITH_PERMISSIONS(state: any, data: any) {
      state.DATA_USER_ME_WITH_PERMISSIONS = data;
    },
    SET_USERS(state: any, data: any) {
      state.DATA_USERS = data;
    },
    SET_COURIERS(state: any, data: any) {
      state.DATA_COURIERS = data;
    },
    SET_DATA_USERS_VERSION(state: any) {
      state.DATA_USERS_VERSION = Math.random();
    },
    SET_TOTAL_USERS(state: any, data: any) {
      state.TOTAL_USERS = data;
    },
    UPDATED_OBJ_FROM_USERS(state: any, data: any) {
      state.DATA_USERS = state.DATA_USERS.map((item: any) => {
        return item.id === data.id ? { ...item, ...data } : item;
      });
    },
    DELETE_OBJ_FROM_USERS(state: any, id: number) {
      state.DATA_USERS = state.DATA_USERS.filter((item: any) => {
        return item.id !== id;
      });
      state.TOTAL_USERS = state.TOTAL_USERS - 1;
    },
    SET_DETAIL_DATA_USER(state: any, data: any) {
      state.DETAIL_DATA_USER = data;
    },
    SET_USER_ROLES(state: any, data: any) {
      state.DATA_USER_ROLES = data;
    },
  },

  actions: {
    async FETCH_USER_ME_WITH_PERMISSIONS(context: any) {
      try {
        const res = await getUserMeWithPermissions();
        context.commit("SET_USER_ME_WITH_PERMISSIONS", res.data);
        return res.data;
      } catch (error: any) {
        console.log(`Error FETCH_USER_ME_WITH_PERMISSIONS => ${error}`);
        console.log(error.response);
      }
    },

    async FETCH_ALL_USERS(context: any, payload: any) {
      try {
        const res = await getAllUsers(payload);
        context.commit("SET_TOTAL_USERS", res.data.total);
        context.commit("SET_USERS", res.data.items);
      } catch (error: any) {
        console.log(`Error FETCH_ALL_USERS => ${error}`);
        console.log(error.response);
        dispatchNotification(
          "error",
          "Ошибка",
          "Произошла ошибка при получении списка пользователей.",
        );
      }
    },

    async FETCH_ALL_USERS_BY_ROLE_CODENAME(context: any, payload: any) {
      try {
        const res = await getAllUsersByRoleCodename(payload);
        if (payload.codename.row == "courier") {
          context.commit("SET_COURIERS", res.data.items);
        }
      } catch (error: any) {
        console.log(`Error FETCH_ALL_USERS_BY_ROLE_CODENAME => ${error}`);
        console.log(error.response);
        dispatchNotification(
          "error",
          "Ошибка",
          "Произошла ошибка при получении списка пользователей по роли.",
        );
      }
    },

    async CREATE_USER(context: any, payload: any) {
      try {
        const res = await createUser(payload);
        if (res.status === 201) {
          context.commit("SET_DATA_USERS_VERSION");
          dispatchNotification("success", "Успешно", "Пользователь создан.");
          return res.data;
        }
      } catch (error: any) {
        console.log(`Error CREATE_USER => ${error}`);
        console.log(error.response);
        console.log(error.response.status);
        if (error.response.status === 400) {
          dispatchNotification("error", "Ошибка", error.response.data.detail);
        } else {
          dispatchNotification("error", "Ошибка", "Произошла ошибка при создании пользователя.");
        }
      }
    },

    async UPDATE_USER(context: any, payload: any) {
      try {
        const res = await updateUser(payload.id, payload);
        if (res.status === 200) {
          context.commit("UPDATED_OBJ_FROM_USERS", res.data);
          context.commit("SET_DATA_USERS_VERSION");
          dispatchNotification("success", "Успешно", "Пользователь изменён.");
        }
      } catch (error: any) {
        console.log(`Error UPDATE_USER => ${error}`);
        console.log(error.response);
        dispatchNotification("error", "Ошибка", "Произошла ошибка при обновлении пользователя.");
      }
    },

    async DELETE_USER(context: any, id: number) {
      try {
        const res = await deleteUser(id);
        if (res.status === 204) {
          context.commit("DELETE_OBJ_FROM_USERS", id);
          context.commit("SET_DATA_USERS_VERSION");
          dispatchNotification("success", "Успешно", "Пользователь удалён.");
        }
      } catch (error: any) {
        console.log(`Error DELETE_USER => ${error}`);
        console.log(error.response);
        dispatchNotification("error", "Ошибка", "Произошла ошибка при удалении пользователя.");
      }
    },

    async FETCH_DETAIL_DATA_USER(context: any, user_id: number) {
      try {
        const res = await getUserById(user_id);
        context.commit("SET_DETAIL_DATA_USER", res.data);
      } catch (error: any) {
        console.log(`Error FETCH_DETAIL_DATA_USER => ${error}`);
        console.log(error.response);
        dispatchNotification(
          "error",
          "Ошибка",
          "Произошла ошибка при получении данных пользователя.",
        );
      }
    },

    async FETCH_USER_ROLES(context: any, role_id: number) {
      try {
        const res = await getRolesByUserId(role_id);
        if (res.status === 200) {
          context.commit("SET_USER_ROLES", res.data);
          return res.data;
        }
      } catch (error: any) {
        console.log(`Error FETCH_USER_ROLES=> ${error}`);
        console.log(error.response);
        dispatchNotification(
          "error",
          "Ошибка",
          "Произошла ошибка при получении ролей пользователя.",
        );
      }
    },

    async UPDATE_USERS_ROLES(context: any, payload: any) {
      try {
        const { id, ...data } = payload;
        const res = await updateUsersRoles(id, data);
        if (res.status === 200) {
          dispatchNotification("success", "Успешно", "Роли пользователя изменены.");
          return res.data;
        }
      } catch (error: any) {
        console.log(`Error UPDATE_USERS_ROLES => ${error}`);
        console.log(error.response);
        dispatchNotification(
          "error",
          "Ошибка",
          "Произошла ошибка при изменении роли пользователя.",
        );
      }
    },
  },
};
